import React from "react";
import Landing from "../component/Landing";

function LandingPage() {
    return <Landing />;
}

export default LandingPage;